import React from 'react';

import Button from '@atlaskit/button';
import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';
import Lozenge from '@atlaskit/lozenge';

import { FEATURE_FLAG } from '@qality/common-config';

import {
  ImageStyled,
  LinkStyled,
  MarkStyled,
  TileContainer,
} from './OnboardingTile.styled';

type Props = { src: string; text: string; link: string; isPlusOnly: boolean };

export default function TestCaseRepositoryOnboarding({
  src,
  text,
  link,
  isPlusOnly,
}: Props): JSX.Element {
  const openDocumentationPage = () => {
    window.open(link, '_blank');
  };

  const isMarkVisible = isPlusOnly && !FEATURE_FLAG.isPremium;

  return (
    <TileContainer>
      {isMarkVisible && (
        <MarkStyled>
          <Lozenge appearance='moved'>ONLY IN QALITY PLUS</Lozenge>
        </MarkStyled>
      )}
      <ImageStyled src={src} />
      <LinkStyled>
        <Button
          appearance='subtle'
          iconAfter={<ArrowRightIcon label='' />}
          onClick={openDocumentationPage}
        >
          {text}
        </Button>
      </LinkStyled>
    </TileContainer>
  );
}
